import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [expandedSection, setExpandedSection] = useState(null);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(
      product.id,
      quantity,
      product.size?.[0] || "One Size",
      selectedColor
    );
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const increaseQuantity = () => {
    setQuantity(quantity + 1);
  };

  return (
    <div className="product-detail">
      <div className="product-detail-container">
        <div className="product-detail-content">
          <div className="product-images-section">
            <div className="main-image-container">
              <img
                src={product.images?.[selectedImage] || product.image}
                alt={product.name}
                className="main-image"
              />
            </div>
            {product.images && product.images.length > 1 && (
              <div className="thumbnail-images">
                {product.images.map((img, idx) => (
                  <button
                    key={idx}
                    className={`thumbnail-btn ${
                      selectedImage === idx ? "active" : ""
                    }`}
                    onClick={() => setSelectedImage(idx)}
                  >
                    <img src={img} alt={`View ${idx + 1}`} />
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="product-info-section">
            <h1 className="product-title">{product.name}</h1>
            <p className="product-price">${product.price} SGD</p>

            <div className="quantity-selector">
              <button className="quantity-btn" onClick={decreaseQuantity}>
                −
              </button>
              <span className="quantity-value">{quantity}</span>
              <button className="quantity-btn" onClick={increaseQuantity}>
                +
              </button>
            </div>

            {product.colors && product.colors.length > 0 && (
              <div className="color-selector">
                <span className="selector-label">Color</span>
                <span className="selected-color">{selectedColor}</span>
                <div className="color-options">
                  {product.colors.map((color) => (
                    <button
                      key={color}
                      className={`color-option ${
                        selectedColor === color ? "active" : ""
                      }`}
                      onClick={() => setSelectedColor(color)}
                      style={{
                        backgroundColor:
                          color === "Gold"
                            ? "#d4af37"
                            : color === "Silver"
                            ? "#c0c0c0"
                            : color === "White Gold"
                            ? "#e6e6fa"
                            : "#808080",
                      }}
                      title={color}
                    />
                  ))}
                </div>
              </div>
            )}

            <button className="add-to-cart-btn" onClick={handleAddToCart}>
              Add to Cart - ${(parseFloat(product.price) * quantity).toFixed(2)}{" "}
              SGD
            </button>

            <div className="accordion-sections">
              <div className="accordion-section">
                <button
                  className="accordion-header"
                  onClick={() => toggleSection("description")}
                >
                  <span>Description</span>
                  <svg
                    className={`accordion-icon ${
                      expandedSection === "description" ? "expanded" : ""
                    }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                {expandedSection === "description" && (
                  <div className="accordion-content">
                    {product.description &&
                      product.description.map((desc, idx) => (
                        <p key={idx}>{desc}</p>
                      ))}
                    {product.material && (
                      <p>
                        <strong>Material:</strong> {product.material}
                      </p>
                    )}
                  </div>
                )}
              </div>

              <div className="accordion-section">
                <button
                  className="accordion-header"
                  onClick={() => toggleSection("features")}
                >
                  <span>Features</span>
                  <svg
                    className={`accordion-icon ${
                      expandedSection === "features" ? "expanded" : ""
                    }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                {expandedSection === "features" && (
                  <div className="accordion-content">
                    {product.Features &&
                      product.Features.map((feature, idx) => (
                        <p key={idx}>• {feature}</p>
                      ))}
                  </div>
                )}
              </div>

              <div className="accordion-section">
                <button
                  className="accordion-header"
                  onClick={() => toggleSection("care")}
                >
                  <span>Care</span>
                  <svg
                    className={`accordion-icon ${
                      expandedSection === "care" ? "expanded" : ""
                    }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                {expandedSection === "care" && (
                  <div className="accordion-content">
                    <p>
                      To keep your jewelry looking its best, avoid contact with
                      water, perfume, and chemicals. Store in a cool, dry place
                      when not in use. Clean with a soft cloth.
                    </p>
                  </div>
                )}
              </div>

              <div className="accordion-section">
                <button
                  className="accordion-header"
                  onClick={() => toggleSection("shipping")}
                >
                  <span>Shipping</span>
                  <svg
                    className={`accordion-icon ${
                      expandedSection === "shipping" ? "expanded" : ""
                    }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>
                {expandedSection === "shipping" && (
                  <div className="accordion-content">
                    <p>Free shipping on domestic orders over $150</p>
                  </div>
                )}
              </div>
            </div>

            <button className="share-btn">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                <polyline points="16 6 12 2 8 6" />
                <line x1="12" y1="2" x2="12" y2="15" />
              </svg>
              SHARE
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
